import { Payment } from '.'

export class ExpenseOrder extends Payment {
  get appraisalAuto () {
    const { deal } = this

    return deal?.auto
  }
}
